module.exports = new Promise((resolve, reject) => {
    const cfg = window.__CLAUDIA_APP__;
    const url = (cfg && cfg.remoteEntryUrl) || null;
    if (!url) {
      reject(new Error('claudia-app remoteEntryUrl missing on window.__CLAUDIA_APP__'));
      return;
    }
    const script = document.createElement('script');
    script.src = url + '?t=' + Date.now();
    script.onload = () => resolve(window.claudiaApp);
    script.onerror = () => reject(new Error('failed to load claudia-app remoteEntry from ' + url));
    document.head.appendChild(script);
  });